import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { typeLabel } from "@/utils/media";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - ${typeLabel(movie.type)} - 蘑菇视频`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/95 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {typeLabel(movie.type)}
        </span>
        {movie.badge && (
          <span className="absolute right-2 top-2 rounded-md bg-accent-500/95 px-2 py-0.5 text-[11px] font-medium text-background-50">
            {movie.badge}
          </span>
        )}
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 text-[12px] font-semibold text-primary-200">
          <i className="ri-star-fill text-[11px]" />
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-3.5">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.genres.join(" · ")} · {movie.year}
        </p>
        <p className="mt-2 flex items-center gap-1 truncate text-xs text-foreground-400">
          <i className="ri-user-3-line text-[13px]" />
          {movie.actors.slice(0, 2).join(" / ")}
        </p>
        <div className="mt-2.5 flex items-center justify-between border-t border-background-200 pt-2.5 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line" />
            {movie.region}
          </span>
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-fire-line" />
            {movie.popularity}
          </span>
        </div>
      </div>
    </Link>
  );
}